<script setup>
import { getCurrentInstance, ref } from 'vue'
import { notifyDialog, notifyDialogError } from '../composables/useDialogNotice'

const amount = ref(5)
const amountInput = ref(5)
const loading = ref(false)
const { proxy } = getCurrentInstance()

function setAmount(val) {
    amountInput.value = val
    amount.value = val
}

function applyCustomAmount() {
    const parsed = parseFloat(amountInput.value)
    if (!isNaN(parsed) && parsed >= 1) {
        amount.value = Math.round(parsed * 100) / 100
    }
}

async function openDonation() {
    applyCustomAmount()
    if (loading.value) return

    loading.value = true
    try {
        const result = await proxy.$api({
            serviceName: 'stripeCheckout',
            methodName: 'createDonationCheckout',
            parameters: [amount.value],
        })

        if (result?.url) {
            window.location.assign(result.url)
            return
        }

        notifyDialog({ type: 'error', message: result?.error || 'Could not create the Stripe Checkout session.' })
    } catch (exception) {
        console.error('Stripe donation error:', exception)
        notifyDialogError(exception, 'Could not connect to the payment server.')
    } finally {
        loading.value = false
    }
}
</script>

<template><div class="donation-wrapper">

        <!-- Sélection du montant -->
        <div class="amount-section">
            <div class="amount-presets">
                <button v-for="preset in [2, 5, 10, 20]" :key="preset" class="preset-btn" :class="{ active: amount === preset }" @click="setAmount(preset)">
                    €{{ preset }}
                </button>
            </div>

            <div class="custom-row">
                <span class="currency-symbol">€</span>
                <input v-model.number="amountInput" type="number" min="1" step="1" placeholder="Other amount" class="custom-input" @blur="applyCustomAmount" @keyup.enter="applyCustomAmount" />
            </div>
        </div>

        <button class="stripe-btn" :disabled="loading" @click="openDonation">
            <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/stripe.svg" alt="Stripe" class="stripe-logo" />
            <span>{{ loading ? 'Opening…' : `Donate €${amount.toFixed(2)}` }}</span>
        </button>

    </div></template>

<style scoped>
.donation-wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    padding: 4px 0;
}
/* ---- Montants ---- */ .amount-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.amount-presets {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
}
.preset-btn {
    background: var(--glass);
    border: 1px solid var(--line-strong);
    border-radius: 8px;
    color: var(--ink);
    font-size: 1rem;
    font-weight: 600;
    padding: 10px 0;
    cursor: pointer;
    transition: all 0.15s ease;
}
.preset-btn:hover {
    background: rgba(239, 83, 80, 0.2);
    border-color: #ef5350;
}
.preset-btn.active {
    background: #ef5350;
    border-color: #ef5350;
    color: #fff;
}
/* ---- Champ custom ---- */ .custom-row {
    display: flex;
    align-items: center;
    background: var(--glass);
    border: 1px solid var(--line-strong);
    border-radius: 8px;
    overflow: hidden;
    transition: border-color 0.15s;
}
.custom-row:focus-within {
    border-color: #ef5350;
}
.currency-symbol {
    padding: 0 12px;
    color: var(--mute);
    font-size: 1rem;
    font-weight: 600;
    user-select: none;
}
.custom-input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: var(--ink);
    font-size: 0.95rem;
    padding: 11px 12px 11px 0;
}
.custom-input::placeholder {
    color: var(--faint);
}
.error-message {
    margin: 0;
    color: var(--status-danger);
    font-size: 0.88rem;
    text-align: center;
}
.stripe-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background: #635bff;
    border: none;
    border-radius: 8px;
    padding: 13px 20px;
    cursor: pointer;
    font-weight: 700;
    font-size: 1rem;
    color: #fff;
    transition: background 0.15s, transform 0.1s;
    width: 100%;
}
.stripe-btn:hover:not(:disabled) {
    background: #7a73ff;
    transform: translateY(-1px);
}
.stripe-btn:active {
    transform: translateY(0);
}
.stripe-btn:disabled {
    cursor: wait;
    opacity: 0.7;
}
.stripe-logo {
    height: 20px;
    width: auto;
    filter: brightness(0) invert(1);
}
</style>
